export default "__VITE_ASSET__38f0285e__"